import axios from 'axios';
import tools, { getAppData, showToast } from '../utils/index';

const failCallback = (msg) => {
  console.log('@failCallback', msg);
  showToast(msg);
  throw Error(msg);
};

const service = axios.create({
  timeout: 1000 * 30
});

service.interceptors.request.use(async (req) => {
  let header = {};
  if (tools.isApp()) {
    let res = await getAppData();
    if (res) {
      header = {
        'Souche-Inc-Security-Token': res['Souche-Inc-Security-Token'],
        'app': res.app,
        'clienttype': res.clienttype,
        'version': res.version
      };
    }
  } else {
    header = {
      'Souche-Inc-Security-Token': tools.fetchParams('token'),
      'app': tools.fetchParams('app'),
      'clienttype': tools.fetchParams('clienttype'),
      'version': tools.fetchParams('version')
    };
  }
  req.headers = { ...req.headers, ...header };
  return req;
}, (error) => {
  Promise.reject(error);
});

service.interceptors.response.use(
  (res) => {
    // status === 200时，其中code === '0' 为兼容老接口
    if (res.data.code !== null && res.data.code !== undefined && (
      [200, '200', '0', '10001'].includes(res.data.code)
    )) {
      return res.data || {};
    } else {
      failCallback(res.data.msg);
    }
  },
  (err) => {
    // status 非 200 时
    if (err.response && err.response.data) {
      failCallback(err.response.data.msg);
    }
    // Promise.reject(err);
  }
);

export default service;



// WEBPACK FOOTER //
// ./src/api/axios.js